// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__CLSE9","label":"LabeledBox_label__130bb"};